import { Component, Input, OnChanges, Output, SimpleChanges, EventEmitter } from '@angular/core';

import { SecurityContextService } from 'rev-shared/security/SecurityContext.Service';
import { orderBy } from 'rev-shared/util/SortUtil';

import { IPlaylistSortInfo, IVideoPlaylist } from './VideoPlaylist.Contract';

import styles from './video-playlist.module.less';

@Component({
	selector: 'video-playlist',
	templateUrl: './VideoPlaylist.Component.html'
})
export class VideoPlaylistComponent implements OnChanges {
	@Input() public isPlaylistSaving: boolean;
	@Input() private playlistCollection: IVideoPlaylist[];
	@Input() private sortInfo: IPlaylistSortInfo;
	@Input() private isUpdatingPlaylist: boolean;

	@Output() public onCancelPlaylist: EventEmitter<any> = new EventEmitter();
	@Output() public onSavePlaylists: EventEmitter<any> = new EventEmitter();
	@Output() public onUpdatePlaylist: EventEmitter<any> = new EventEmitter();

	public readonly styles = styles;
	public featuredPlaylist: IVideoPlaylist;
	public userPlaylists: IVideoPlaylist[];

	constructor(
		private SecurityContext: SecurityContextService,
	) { }

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.playlistCollection && this.playlistCollection) {
			this.userPlaylists = this.playlistCollection.filter(playlist => playlist.id !== 'featured');
			this.featuredPlaylist = this.playlistCollection.find(playlist => playlist.id === 'featured');
		}
		if (changes.sortInfo) {
			this.userPlaylists = orderBy(this.userPlaylists, playlist => playlist[this.sortInfo.field], this.sortInfo.sortAscending);
		}
	}

	public savePlaylists(): void {
		this.onSavePlaylists.emit({
			playlists: this.playlistCollection
		});
	}

	public updatePlaylist({ playlist }: { playlist: IVideoPlaylist; }): void {
		this.onUpdatePlaylist.emit({
			playlist
		});
	}

	public onCancel(): void {
		this.onCancelPlaylist.emit();
	}

	public get showFeaturedPlaylist(): boolean {
		return this.featuredPlaylist && this.isFeaturedPlaylistAuthorized;
	}

	private get isFeaturedPlaylistAuthorized(): boolean {
		return this.SecurityContext.checkAuthorization('media.featuredPlaylist');
	}
}
